import type { NodePropertySchema } from '../../../types/node-properties';

/**
 * Respond to Trigger Node Schema
 * 
 * This node sends a response back to the trigger (Chat or Webhook) and optionally commits it to memory.
 */
const schema: NodePropertySchema = {
  nodeType: 'respond-to-trigger',
  version: '1.0.0',
  
  properties: [
    // ==================================================================
    // RESPONSE MESSAGE
    // ==================================================================
    {
      key: 'message',
      label: 'Response Message',
      type: 'text',
      typeOptions: {
        rows: 4
      },
      default: '',
      required: false,
      description: 'The message to send back to the chat. Leave empty to automatically use the output from the previous node (e.g., AI Agent). Supports variable interpolation like {{variableName}}',
      placeholder: 'Leave empty to use previous node output, or enter a custom message...'
    },
    
    // ==================================================================
    // MEMORY OPTIONS
    // ==================================================================
    {
      key: 'commitToMemory',
      label: 'Commit to Memory',
      type: 'boolean',
      default: true,
      description: 'Save this response to the conversation memory. Requires a session ID from Chat Trigger.',
    },
    
    // ==================================================================
    // RESPONSE TYPE
    // ==================================================================
    {
      key: 'responseType',
      label: 'Response Type',
      type: 'options',
      options: [
        { label: 'Text', value: 'text' },
        { label: 'JSON', value: 'json' }
      ],
      default: 'text',
      description: 'The format of the response'
    },
    
    // ==================================================================
    // METADATA (OPTIONAL)
    // ==================================================================
    {
      key: 'metadata',
      label: 'Metadata (JSON)',
      type: 'json',
      default: '{}',
      description: 'Optional metadata to include with the response',
      placeholder: '{ "source": "workflow", "version": "1.0" }'
    }
  ],
  
  metadata: {
    author: 'Evo E2E Team',
    documentation: 'https://docs.evoe2e.com/nodes/respond-to-trigger'
  }
};

export default schema;
